<template>
  <div id="app">
  <v-app id="inspire">
    <v-toolbar
      color="blue darken-3"
      dark
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
    >
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">Beautiful</span>
      </v-toolbar-title>
      <searcher @searched="setSymbol"/>
    </v-toolbar>
    <v-content>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <quote :symbol="symbol" :quote="quote"></quote>
          </v-flex>
          <v-flex xs12>
            <filters :expirations="expirations" :options="options" @daterange-selected="selectDateRange" @strikerange-selected="selectStrikeRange"></filters>
          </v-flex>
          <v-flex xs12>
            <options-ratio :options="filteredOptions"></options-ratio>
          </v-flex>
          <v-flex xs12>
            <options-chain v-if="options" :option-chain="filteredOptions" :quote="quote"></options-chain>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</div>
</template>

<script>
import _ from 'lodash';
import OptionsChain from './components/Options/Chain.vue';
import OptionsRatio from './components/Options/Ratio.vue';
import Quote from './components/Underlying/Quote.vue';
import Filters from './components/Filters.vue';
import Searcher from './components/Searcher.vue';

export default {
  name: 'App',
  components: {
    OptionsChain,
    OptionsRatio,
    Filters,
    Searcher,
    Quote,
  },
  props: {
    source: String,
  },
  data() {
    return {
      drawer: false,
      symbol: '',
      expirations: [],
      options: null,
      dateRange: null,
      strikeRange: null,
      quote: null,

    };
  },
  computed: {
    filteredOptions() {
      if (this.options) {
        if (this.strikeRange) {
          const deepCopy = JSON.parse(JSON.stringify(this.options));
          Object.keys(deepCopy).forEach((expiration) => {
            deepCopy[expiration] = deepCopy[expiration].filter(opt => opt.strike >= this.strikeRange.min && opt.strike <= this.strikeRange.max);
          });

          return deepCopy;
        }
        return this.options;
      }
      return null;
    },
  },
  methods: {
    selectDateRange(val) {
      this.dateRange = val;
      const startIndex = this.expirations.indexOf(val.start);
      const endIndex = this.expirations.indexOf(val.end);
      for (let x = startIndex; x <= endIndex; x += 1) {
        const expiry = this.expirations[x];
        if (!this.options || !Object.prototype.hasOwnProperty.call(this.options, expiry)) {
          this.getOptions(expiry);
        }
      }
    },
    selectStrikeRange(val) {
      this.strikeRange = { min: val[0], max: val[1] };
    },
    setExpirations(val) {
      this.expirations = val;
    },
    setSymbol(val) {
      this.expirations = [];
      this.options = null;
      this.symbol = val;
      this.getQuote();
    },
    setOptions(val) {
      this.$set(this.options, val.expiration, val.options);
    },
    getExpirations: _.debounce(function () {
      this.expirations = [];
      let url = `https://sandbox.tradier.com/v1/markets/options/expirations?symbol=${this.symbol}`;
      url = encodeURI(url);
      this.$http.get(`${this.$proxy}/cors?url=${url}`, { headers: { 'Access-Control-Allow-Origin': '*' } }).then((data) => {
        this.options = null;
        this.expirations = data.data.expirations.date;
      });
    }, 250),
    getQuote() {
      this.quote = null;
      let url = `https://sandbox.tradier.com/v1/markets/quotes?symbols=${this.symbol}`;
      url = encodeURI(url);
      this.$http.get(`${this.$proxy}/cors?url=${url}`, { headers: { 'Access-Control-Allow-Origin': '*' } }).then((data) => {
        this.quote = data.data.quotes.quote;
      });
    },
    getOptions(expiration) {
      this.isLoading = true;
      let url = `https://sandbox.tradier.com/v1/markets/options/chains?symbol=${this.symbol}&expiration=${expiration}`;
      url = encodeURIComponent(url);
      return this.$http.get(`https://us-central1-beautifulstocks.cloudfunctions.net/cors?url=${url}`, { headers: { 'Access-Control-Allow-Origin': '*' } }).then((data) => {
        if (!this.options) {
          this.options = {};
        }
        this.$set(this.options, expiration, data.data.options.option);
        this.isLoading = false;
      });
    },
    getOptionsForIndex(index) {
      this.getOptions(this.expirations[index]);
    },
  },
  watch: {
    symbol() {
      this.getExpirations();
    },
  },
};
</script>
